<template>
    <div class="container-fluid py-4">
      <template v-if="!isLoading && infant">
        <div class="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-4 pb-3 border-bottom">
          <div>
            <h4 class="text-info mb-1">Detalles del Juvenil</h4>
            <p class="text-sm text-secondary mb-0">
              Trabajador:
              <a class="font-weight-bold" :href="`/trabajadores/${infant.customer?.id}`">
                {{ infant.customer?.name || (infant.customer?.first_name + ' ' + infant.customer?.last_name) }}
              </a>
            </p>
          </div>
          <div class="d-flex flex-wrap gap-2">
            <template v-if="readOnly">
              <button @click="readOnly = false" class="btn btn-info mb-0">Editar Registro</button>
              <button class="btn btn-primary mb-0" @click="printPDF">
                <template v-if="downloading">Imprimiendo ...</template>
                <template v-else>Imprimir Kardex</template>
              </button>
            </template>
            <template v-else>
              <button @click="readOnly = true" class="btn btn-secondary mb-0">Descartar</button>
              <button @click.stop="update" class="btn btn-success mb-0">Guardar</button>
            </template>
            <button @click.stop="deleteYouth" class="btn btn-danger mb-0">Eliminar</button>
          </div>
        </div>

        <div class="row d-flex">
          <div class="col-xs-12 col-lg-8">
            <div class="mb-3">
              <label class="form-label text-primary">Nombre completo</label>
              <input :disabled="readOnly" type="text" class="form-control" v-model="infant.first_name">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Edad</label>
              <input type="text" class="form-control" v-model="infant.age" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">E-mail</label>
              <input type="text" class="form-control" v-model="infant.email" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Condición Médica</label>
              <input type="text" class="form-control" v-model="infant.allergy" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Equipo (País)</label>
              <select v-if="!readOnly" class="form-control" v-model="selectedTeamId">
                <option :value="null">— Selecciona un país —</option>
                <option v-for="option in teams" :value="option.id" :key="option.id">{{ option.name }}</option>
              </select>
              <input v-if="readOnly && selectedTeam" type="text" class="form-control" :value="selectedTeam.name" :disabled="true">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Continente</label>
              <input type="text" class="form-control" :value="selectedTeam?.continent || 'Selecciona un país activo'" :disabled="true">
            </div>
          </div>
        </div>

        <h6 class="text-primary mt-2">Responsable</h6>
        <div class="row d-flex">
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Nombre del responsable</label>
              <input type="text" class="form-control" v-model="infant.person_name" :disabled="readOnly">
            </div>
          </div>
          <div class="col-xs-12 col-lg-4">
            <div class="mb-3">
              <label class="form-label text-primary">Teléfono del responsable</label>
              <input type="text" class="form-control" v-model="infant.person_phone" :disabled="readOnly">
            </div>
          </div>
        </div>

        <h6 class="text-primary mt-2">Datos del trabajador <small class="text-secondary">(se editan en la ficha del trabajador)</small></h6>
        <div class="row d-flex">
          <div class="col-xs-12 col-lg-3">
            <div class="mb-3">
              <label class="form-label text-secondary">Matrícula</label>
              <input type="text" class="form-control" :value="infant.customer?.matricula" disabled>
            </div>
          </div>
          <div class="col-xs-12 col-lg-3">
            <div class="mb-3">
              <label class="form-label text-secondary">Área/supervisor</label>
              <input type="text" class="form-control" :value="infant.customer?.area" disabled>
            </div>
          </div>
          <div class="col-xs-12 col-lg-3">
            <div class="mb-3">
              <label class="form-label text-secondary">Teléfono</label>
              <input type="text" class="form-control" :value="infant.customer?.phone" disabled>
            </div>
          </div>
          <div class="col-xs-12 col-lg-3">
            <div class="mb-3">
              <label class="form-label text-secondary">Correo</label>
              <input type="text" class="form-control" :value="infant.customer?.email" disabled>
            </div>
          </div>
        </div>

        <div>
          <h6 class="text-primary">Horario del día ({{ selectedTeam?.continent }})</h6>
          <p v-if="!selectedTeam?.continent" class="text-xs text-danger mb-2">
            Este juvenil no tiene un país activo asignado. Selecciona un país para aplicar el horario por continente.
          </p>
          <table class="table table-bordered schedule">
            <thead>
              <tr>
                <th>Horario</th>
                <th>Actividad</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in currentSchedule" :key="index">
                <td>{{ row[0] }}</td>
                <td :style="recreacionStyle(row[1])">{{ row[1] }}</td>
              </tr>
            </tbody>
          </table>

          <h6 class="text-primary mt-3">Retos</h6>
          <p class="text-xs text-secondary mb-2">
            Opcional. Las opciones dependen del continente. En el kardex impreso el espacio queda en blanco
            para que el joven lo escriba a mano (req. #5).
          </p>
          <div class="row">
            <div v-for="reto in [1, 2, 3]" :key="reto" class="col-12 col-md-4">
              <div class="mb-3">
                <label :for="`reto-${reto}`" class="form-label text-primary">Reto {{ reto }}</label>
                <select v-if="!readOnly" :id="`reto-${reto}`" v-model="retoSelections[reto]" class="form-control">
                  <option :value="null">— Sin asignar —</option>
                  <option v-for="w in retoOptions(reto)" :key="w.id" :value="w.id">{{ w.name }} ({{ w.type }})</option>
                </select>
                <input v-else :id="`reto-${reto}`" type="text" class="form-control" :value="retoName(reto)" disabled>
              </div>
            </div>
          </div>

          <h6 class="text-primary">Ingresos</h6>
          <table class="table table-bordered schedule">
            <thead>
              <tr>
                <th>Dia y hora</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(entrance,index) in infant.entrances" :key="index">
                <td>{{ formatDate(entrance.created_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <template v-else-if="isLoading">
        <p>Cargando datos...</p>
      </template>

      <template v-else>
        <div class="alert alert-danger text-white">
          No pudimos cargar los datos del juvenil.
        </div>
      </template>
    </div>
  </template>

  <script>
  import axios from 'axios';
  import moment from "moment"
  import es from "moment/dist/locale/es";
  moment.updateLocale("es", es);
  const PUBLIC_API_URL = process.env.VUE_APP_PUBLIC_API_URL;

  // Horarios por continente (Verano 2026). El color de "Recreación" cambia por continente.
  const SCHEDULES = {
    'América': [
      ['9:00 a 9:30', 'Dinámica de arranque del día'],
      ['9:30 a 10:20', 'Recreación'],
      ['10:20 a 10:40', 'Snack matutino'],
      ['10:40 a 11:30', 'RETO 1 (ZONA ARTES)'],
      ['11:30 a 11:50', 'Tiempo de creatividad'],
      ['11:50 a 12:40', 'RETO 2'],
      ['12:40 a 13:00', 'Descanso y lonche'],
      ['13:00 a 13:50', 'RETO 3'],
    ],
    'Europa': [
      ['9:00 a 9:30', 'Dinámica de arranque del día'],
      ['9:30 a 10:20', 'RETO 1'],
      ['10:20 a 10:40', 'Snack matutino'],
      ['10:40 a 11:30', 'Recreación'],
      ['11:30 a 11:50', 'Tiempo de creatividad'],
      ['11:50 a 12:40', 'RETO 2'],
      ['12:40 a 13:00', 'Descanso y lonche'],
      ['13:00 a 13:50', 'RETO 3'],
    ],
    'África': [
      ['9:00 a 9:30', 'Dinámica de arranque del día'],
      ['9:30 a 10:20', 'RETO 1'],
      ['10:20 a 10:40', 'Snack matutino'],
      ['10:40 a 11:30', 'RETO 2 (ZONA CIENCIAS)'],
      ['11:30 a 11:50', 'Tiempo de creatividad'],
      ['11:50 a 12:40', 'Recreación'],
      ['12:40 a 13:00', 'Descanso y lonche'],
      ['13:00 a 13:50', 'RETO 3'],
    ],
  };

  const RECREACION_COLORS = {
    'América': '#d32f2f', // rojo
    'Europa': '#1565c0',  // azul
    'África': '#ef6c00',  // naranja
  };

  export default {
    name: 'YouthDetails',

    data() {
      return {
        infant: null,
        isLoading: false,
        readOnly: true,
        teams: [],
        selectedTeamId: null,
        allWorkshops: [],
        workshopOptions: {},
        retoSelections: { 1: null, 2: null, 3: null },
        downloading: false
      };
    },
    created() {
      this.fetchInfantDetails();
    },
    computed: {
      selectedTeam() {
        return this.teams.find(t => t.id === this.selectedTeamId) || null;
      },
      currentSchedule() {
        return SCHEDULES[this.selectedTeam?.continent] || [];
      }
    },
    methods: {
      retoOptions(reto) {
        const continent = this.selectedTeam?.continent;
        if (continent && this.workshopOptions?.[continent]?.[reto]) {
          return this.workshopOptions[continent][reto];
        }

        return this.allRetoOptions(reto);
      },
      allRetoOptions(reto) {
        const byId = {};

        Object.values(this.workshopOptions || {}).forEach((retos) => {
          (retos?.[reto] || []).forEach((workshop) => {
            byId[workshop.id] = workshop;
          });
        });

        return Object.values(byId).sort((a, b) => a.name.localeCompare(b.name));
      },
      buildWorkshopOptions(workshopsResponse) {
        if (workshopsResponse.options) {
          return workshopsResponse.options;
        }

        const options = {};
        const workshops = [
          ...(workshopsResponse.science || []),
          ...(workshopsResponse.art || []),
        ];

        workshops.forEach((workshop) => {
          (workshop.reto_options || []).forEach((option) => {
            if (!options[option.continent]) options[option.continent] = {};
            if (!options[option.continent][option.reto]) options[option.continent][option.reto] = [];
            options[option.continent][option.reto].push({
              id: workshop.id,
              name: workshop.name,
              type: workshop.type,
            });
          });
        });

        return options;
      },
      retoName(reto) {
        const w = this.allWorkshops.find(x => x.id === this.retoSelections[reto]);
        return w ? w.name : 'Sin asignar';
      },
      async fetchInfantDetails() {
        this.isLoading = true;
        const id = this.$route.params.id;
        try {
          const response = await axios.get(`${PUBLIC_API_URL}/youths/${id}`);
          const responseTeams = await axios.get(`${PUBLIC_API_URL}/teams-youths`);
          const responseWorkshops = await axios.get(`${PUBLIC_API_URL}/workshops/list`);
          this.infant = response.data;

          // Nombre completo en un solo campo: registros viejos con apellido
          // separado se fusionan en first_name y last_name queda en null.
          this.infant.first_name = [this.infant.first_name, this.infant.last_name]
            .filter(Boolean).join(' ').trim();
          this.infant.last_name = null;

          this.teams = responseTeams.data;
          this.allWorkshops = [
            ...(responseWorkshops.data.science || []),
            ...(responseWorkshops.data.art || []),
          ];
          this.workshopOptions = this.buildWorkshopOptions(responseWorkshops.data);

          const current = this.infant.teams[0];
          if (current) {
            const activeTeam = this.teams.find(t => t.id === current.id);
            this.selectedTeamId = activeTeam ? activeTeam.id : null;
          }

          // Cargar retos asignados (pivot.reto).
          this.retoSelections = { 1: null, 2: null, 3: null };
          (this.infant.workshops || []).forEach(w => {
            const reto = w.pivot?.reto;
            if (reto >= 1 && reto <= 3) {
              this.retoSelections[reto] = w.id;
            }
          });
        } catch (error) {
          this.$swal({
            title: "Ocurrio un error!",
            text: "No pudimos obtener los datos del juvenil!",
            icon: "error"
          });
        }
        this.isLoading = false;
      },
      async update() {
        this.isLoading = true;
        try {
          const workshops = [];
          [1, 2, 3].forEach(reto => {
            if (this.retoSelections[reto]) {
              workshops.push({ id: this.retoSelections[reto], reto });
            }
          });
          const payload = {
            ...this.infant,
            'team_id': this.selectedTeamId,
            'workshops': workshops
          }
          await axios.put(`${PUBLIC_API_URL}/youths/${this.infant.id}`, payload);
          this.fetchInfantDetails()
          this.readOnly = true
          this.$swal({
            title: "Actualizado con Exito!",
            text: "Los datos del juvenil fueron actualizados!",
            icon: "success"
          });
        } catch (error) {
          this.$swal({
            title: "Ocurrio un error!",
            text: "No pudimos actualizar los datos del juvenil!",
            icon: "error"
          });
        }
      },
      recreacionStyle(activity) {
        if (activity === 'Recreación') {
          return { color: RECREACION_COLORS[this.selectedTeam?.continent] || '#000', fontWeight: 'bold' };
        }
        return {};
      },
      printPDF() {
        try {
          this.downloading = true;
          const id = this.$route.params.id;
          const url = `${PUBLIC_API_URL}/youths/${id}/pdf`;
          const link = document.createElement('a');
          link.href = url;
          document.body.appendChild(link);
          link.click();
          this.downloading = false;
        } catch (error) {
          this.$swal({
            title: "Ocurrio un error!",
            text: error,
            icon: "error"
          });
          this.downloading = false;
        }
      },
      formatDate(date) {
        let localTime = moment.utc(date).toDate();
        return moment(localTime).format('LLLL');
      },
      async deleteYouth() {
        const result = await this.$swal({
          title: "¿Eliminar juvenil?",
          text: "Esta acción no se puede deshacer.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#dc3545",
        });

        if (!result.isConfirmed) return;

        try {
          await axios.delete(`${PUBLIC_API_URL}/youths/${this.infant.id}`);
          this.$swal({
            title: "Eliminado con Éxito!",
            text: "El juvenil fue eliminado.",
            icon: "success"
          });
          this.$router.push('/recreativo-juvenil');
        } catch (error) {
          this.$swal({
            title: "Ocurrio un error!",
            text: "No pudimos eliminar al juvenil!",
            icon: "error"
          });
        }
      }
    }
  };
  </script>

  <style scoped>
    .header, .footer {
      margin-bottom: 20px;
    }
    .label {
      font-weight: bold;
    }
    .value {
      margin-bottom: 5px;
    }
  </style>
